import { twMerge } from "tailwind-merge";

type ErrorProps = {
  message?: string | null;
  className?: string;
};

export const Error = ({ message, className }: ErrorProps) => {
  const classes = twMerge("text-error text-sm block", className);
  if (!message) return null;
  return <span className={classes}>{message}</span>;
};
